<template>
    <div :id="id">
        <div style="position:relative;overflow:hidden;">
            <a href="https://yandex.ru/maps/org/grand_otel_emerald/1012227590/?utm_medium=mapframe&utm_source=maps" style="color:#eee;font-size:12px;position:absolute;top:0px;">Гранд Отель Эмеральд</a>
            <a href="https://yandex.ru/maps/2/saint-petersburg/category/hotel/184106414/?utm_medium=mapframe&utm_source=maps" style="color:#eee;font-size:12px;position:absolute;top:14px;">Гостиница в Санкт‑Петербурге</a>
            <iframe src="https://yandex.ru/map-widget/v1/org/grand_otel_emerald/1012227590/?ll=30.371088%2C59.935647&source=serp_navig&utm_source=share&z=17" 
                width="100%" 
                height="400"
                frameborder="1"
                allowfullscreen="true"
                style="position:relative;">
            </iframe>
        </div>
    </div>
</template>
<script>
export default {
    name: 'MapBlock',
    components: {},
    props: {},
    data() {
        return {
            id: "yandex-map-wrap",
            //url: "https://api-maps.yandex.ru/services/constructor/1.0/js/?um=constructor%3Abe8cccafa35556b8f7e479ab6f37fae0e2233584ac6c8d9c158099d864fc4616&amp;width=633&amp;height=400&amp;lang=ru_RU&amp;scroll=true",
            
            // width: ""
        }
    },
    mounted() {
        // this.createMap()
    },
    methods: {
        // createMap: function() {
        //     let script = document.createElement('script')
        //     // script.src = this.url
        //     script.setAttribute( 'src', this.url)
        //     script.async = true
        //     // script.charset = "utf-8"
        //     document.querySelector('#'+this.id).append(script)
        // },
    }
}
</script>
<style lang="scss">
// #yandex-map-wrap{
//     // border-radius: 15px;
//     // overflow: hidden;
//     // display: flex;
//     // justify-content: center;
//     // align-items: center;
//     // background: #c12828;
//     // padding: 0;
//     // margin: 0;
// }
</style>

